<script>
	import { active_breadcrumb, project_list, show_sidebar } from '../../app-store';
	import { navigate } from 'svelte-routing';
	import LegacyComponentWrapper from '../../frame-components/legacy-component-wrapper.svelte';
    import { append_empty_stylesheet } from 'svelte/internal';

	let legacy_component =  {
		id: "project-list",
		screen_container_el: null,
		_crate_offcanvas: function ({ id, title, content_el }) {
			const body_el = tag.div({ class: "offcanvas-body" }, content_el ? content_el : "");
			const el = tag.div(
				{
					class: "offcanvas offcanvas-end",
					style: "width: 500px", /* temporary until we move the component */
					tabindex: "-1",
					id: id,
					"aria-labelledby": "offcanvasRightLabel",
				},
				tag.div(
					{ class: "offcanvas-header" },
					tag.h5({ class: "offcanvas-title", id: "offcanvasRightLabel" }, title),
					tag.button({
						type: "button",
						class: "btn-close",
						"data-bs-dismiss": "offcanvas",
						"aria-label": "Close",
					})
				),
				body_el
			);
			return {
				el,
				body_el,
				set_title: (title) => {
					el.querySelector(".offcanvas-title").textContent = title;
				},
				append_tobody: (el) => {
					body_el.appendChild(el);
				},
				empty: () => {
					body_el.innerHTML = "";
				},
			};
		},
		_create_project_add_card: function ({ onclick }) {
			const project_add_card_el = tag.article(
				{ class: "panel project-item animate-in", role: "button", onclick: onclick },
				tag.div(
					{ class: "project-item-body justify-content-center" },
					tag.div({ class: "panel-title project-item-name text-center" }, [
						tag.img({
							src: "/img/add-line.svg",
							alt: "Add Project",
							class: "opacity-25 d-block mx-auto",
							width: 64,
							height: 64,
						}),
						"Create New Project",
					])
				)
			);
			return {
				el: project_add_card_el,
			};
		},
		_create_project_card_el: function ({ name, product_name, onclick, onsettingclick }) {
			return tag.div({ class: "card project-card" }, [
				tag.div(
					{ class: "card-body project-item animate-in", role: "button", tabindex: 0, onclick: onclick },
					tag.div({ class: "project-item-body" }, [
						tag.div({ class: "panel-title project-item-name" }, name),
						tag.div({ class: "panel-description project-item-product-name text-muted fw-light" }, product_name)
					])
				),
				tag.div(
					{ class: "card-footer" },
					tag.button(
						{ class: "btn btn-light btn-project-setting", onclick: onsettingclick },
						tag.img({ src: "/img/settings-5-line.svg", width: 30, height: 30 })
					)
				),
			]);
		},
		_create_error_alert_el: function (message) {
			return tag.article(
				{ class: "alert alert-danger project-item animate-in" },
				tag.div({ class: "project-item-body" }, [
					tag.div({ class: "alert-title fw-bold"}, "Error"),
					tag.div({ class: "alert-message" }, message)
				])
			);
		},
		show: function () {
			document.getElementById(this.id).classList.remove("hidden");
		},
		hide: function () {
			document.getElementById(this.id).classList.add("hidden");
		},
		onshow: async function () {
			app.chat_manager.hide();
			active_breadcrumb.set("breadcrumb-project-list");
			// Force sidebar to close
			show_sidebar.set(false);

			const offcanvas = this._crate_offcanvas({
				id: "offcanvas-create-project",
				title: "Create Project",
			});

			const project_card_wrapper_el = tag.div({ class: "project-card-wrapper" });

			try {
				// Fetch projects
				app.body_spinner.add_to(document.body);
				const { projects } = await app.lucep_ai.get_projects();

				// Create project cards
				const project_card_els = [];
				for (const project of projects) {
					// Project cards for main container
					const project_card_el = this._create_project_card_el({
						name: project.name,
						product_name: project.config.product_name || "",
						onclick: async () => {


							project_list.update((projects) =>
								projects.map((p) => ({
									...p,
									is_active: p.project_ref === project.project_ref,
									drafts: p.drafts.map((d) => ({
										...d,
										is_active: false
									}))
								}))
							);

							// Navigate to new draft screen
							navigate(`/project/${project.project_ref}`);
						},
						onsettingclick: () => {
							offcanvas.empty();
							offcanvas.set_title("Project Settings");

							const project_settings_component = new web_svelte.ProjectSettings({
								target: offcanvas.body_el,
								props: {
									project: project,
									onSubmit : () => { }
								}
							});

							const bs_ofcanvas = new bootstrap.Offcanvas(offcanvas.el);
							bs_ofcanvas.show();
						},
					});
					project_card_els.push(project_card_el);
				}

				// Add project card
				const project_add_card = this._create_project_add_card({
					onclick: async () => {
						offcanvas.empty();
						offcanvas.set_title("Create Project");

						const project_settings_component = new web_svelte.ProjectSettings({
							target: offcanvas.body_el,
							props: {
								project: null,
								onSubmit : () => {
									this.onshow();
									project_settings_component.$destroy();
								}
							}
						});

						const bs_ofcanvas = new bootstrap.Offcanvas(offcanvas.el);
						bs_ofcanvas.show();
					},
				});
				project_card_els.push(project_add_card.el);
				project_card_wrapper_el.append(...project_card_els);
				this.screen_container_el.innerHTML = "";
				this.screen_container_el.appendChild(project_card_wrapper_el);
				this.screen_container_el.appendChild(offcanvas.el);
			} catch (error) {
				console.error("Error fetching projects:", error);
				if (error.status_code === 500) {
					this.screen_container_el.appendChild(this._create_error_alert_el(error_msg.server_error(error.msg)));
				} else {
					this.screen_container_el.appendChild(this._create_error_alert_el(error_msg.client_error(error.msg)));
				}
			} finally {
				app.body_spinner.remove();
			}
		},
		init: function (payload = {}) {
			this.screen_container_el = tag.div({ class: "action-area action-area-project-list" });
			return this.screen_container_el;
		},
	};

</script>

<LegacyComponentWrapper legacy_component={legacy_component} />